export interface FaqItem {
  question: string;
  answer: string;
}

export const faqItems: FaqItem[] = [
  {
    question: '如何注册九游娱乐账号？',
    answer: '点击网站右上角的"注册"按钮，填写手机号码并设置密码，完成短信验证后即可成功注册。整个注册过程仅需1分钟，注册即送新人大礼包。',
  },
  {
    question: '九游娱乐支持哪些支付方式？',
    answer: '我们支持多种安全便捷的支付方式，包括：银行卡转账、微信支付、支付宝、USDT数字货币等。所有支付通道均经过严格安全认证，确保您的资金安全。',
  },
  {
    question: '游戏是否公平公正？',
    answer: '九游娱乐所有游戏均采用国际认证的随机数生成器（RNG），确保每一局游戏结果完全随机、不可预测。我们定期接受第三方权威机构审计，游戏公平性有保障。',
  },
  {
    question: '提现需要多长时间到账？',
    answer: '普通用户提现处理时间为1-2小时，VIP会员享受快速通道，提现最快10分钟到账。具体到账时间视银行处理速度略有差异，节假日正常处理。',
  },
  {
    question: '如何联系客服？',
    answer: '我们提供7×24小时全天候客服服务。您可以通过在线客服、官方热线400-888-9999、或发送邮件至service@jiuyouyule.com联系我们。在线客服平均响应时间不超过30秒。',
  },
  {
    question: '会员等级如何提升？',
    answer: '会员等级根据您的累计游戏活跃度和充值金额自动评定。从普通会员到钻石会员共5个等级，等级越高享受的福利越多，包括更高的返水比例、专属客服、生日礼包等。',
  },
  {
    question: '忘记密码怎么办？',
    answer: '点击登录页面的"忘记密码"，通过注册手机号接收验证码，即可重新设置密码。如遇到任何问题，可随时联系在线客服协助处理。',
  },
  {
    question: '可以在手机上玩游戏吗？',
    answer: '当然可以！九游娱乐支持全平台游戏体验。您可以通过手机浏览器直接访问我们的网站，也可以下载官方APP获得更优化的移动端体验。所有游戏均已适配手机屏幕。',
  },
];

export interface VipBenefit {
  level: string;
  levelName: string;
  icon: string;
  benefits: string[];
  color: string;
}

export const vipBenefits: VipBenefit[] = [
  {
    level: 'VIP1',
    levelName: '青铜会员',
    icon: 'ri-medal-line',
    benefits: ['注册即享', '新人礼包', '每日签到奖励', '基础客服支持'],
    color: 'bg-secondary-500',
  },
  {
    level: 'VIP2',
    levelName: '白银会员',
    icon: 'ri-shield-star-line',
    benefits: ['充值返利5%', '生日礼包', '专属活动参与权', '快速客服通道'],
    color: 'bg-secondary-600',
  },
  {
    level: 'VIP3',
    levelName: '黄金会员',
    icon: 'ri-vip-crown-line',
    benefits: ['充值返利8%', '提现优先处理', '每月免费筹码', '专属客户经理'],
    color: 'bg-accent-500',
  },
  {
    level: 'VIP4',
    levelName: '铂金会员',
    icon: 'ri-vip-diamond-line',
    benefits: ['充值返利12%', '提现极速到账', '私人定制礼遇', '线下活动邀请'],
    color: 'bg-primary-500',
  },
  {
    level: 'VIP5',
    levelName: '钻石会员',
    icon: 'ri-vip-line',
    benefits: ['充值返利18%', '专属VIP客服', '全球奢华旅行', '限量珍品馈赠'],
    color: 'bg-primary-700',
  },
];

export const stats = [
  { value: '5000万+', label: '注册用户' },
  { value: '2000+', label: '精品游戏' },
  { value: '99.9%', label: '服务好评率' },
  { value: '7×24h', label: '客服在线' },
];

export const features = [
  {
    icon: 'ri-shield-check-line',
    title: '安全保障',
    description: '采用国际领先的加密技术，全方位保护您的账户和资金安全，让您安心畅玩。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '极速体验',
    description: '自研游戏引擎，毫秒级响应速度，告别卡顿延迟，畅享丝滑游戏体验。',
  },
  {
    icon: 'ri-verified-badge-line',
    title: '公平公正',
    description: '国际认证RNG随机数生成器，第三方定期审计，确保每一局游戏公平透明。',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: '全天客服',
    description: '7×24小时专业客服团队，平均30秒响应，随时为您解决任何问题。',
  },
];